export default __webpack_public_path__ + "static/g-computer-5e6257a1b97a9ad16f1627dff3d4baa9.jpg";